'use client'

import { useSyncExternalStore } from 'react'
import { isLaunchOfferOn } from './launchOffer'

/** Whether the launch price shows, from `?offer=off` in the URL. On during server render. */
export function useLaunchOffer(): boolean {
  return useSyncExternalStore(
    () => () => {},
    () => isLaunchOfferOn(window.location.search),
    () => true,
  )
}
